<template>
  <v-container grid-list-xl text-xs-center>
    <ReceiptViewer
      v-if="showDialog"
      ref="receiptDetails"
      inspectMode
      v-on:hide="showDialog = false"
      :showDialog="showDialog"
      :receiptImage="receiptImageElement"
      :receiptImageIsLoading="receiptImageIsLoading"
      :editMode="false"
    />
    <v-layout row column>
      <v-flex xs4>
        <v-card elevation-24 style="padding: 20px; border: 1px;">
          <v-card-text>
            <h4 class="display-1 font-weight-bold">Search by Email</h4>
            <v-text-field
              clearable
              v-model="email"
              :error="!emailValidity"
              :hide-details="emailValidity"
              :error-messages="!emailValidity ? 'The email you entered is invalid.': ''"
              label="Consumer's Email Address"
              prepend-icon="mdi-text-search"
              type="text"
              color="black"
              @keypress.enter="searchEmail"
            ></v-text-field>
            <br />
            <v-btn @click="searchEmail" color="grey darken-2" large
              >Search</v-btn
            >
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex style>
        <v-card>
          <v-data-table
            :items="receiptsList"
            :no-data-text="('No receipts found for this email')"
            :disable-pagination="true"
            :hide-default-footer="true"
            sortBy="createdAt"
            :sort-desc="true"
            :headers="headers"
            :loading="false"
          >
            <template slot="item" slot-scope="{ item }">
              <tr @click="setCurrentReceipt(item,item.campaign)" style="cursor: pointer;">
                <td>{{ item.referenceNumber }}</td>
                <td>{{ item.campaignId }}</td>
                <td>{{ item.status }}</td>
                <td>{{ item.createdAt }}</td>
                <td>{{ item.updatedAt }}</td>
                <!-- <td>{{ item.email }}</td> -->
                <!-- <td>{{ item.rejectReason }}</td>
                <td>{{ item.paymentStatus }}</td>
                <td>{{ item.paymentHistory }}</td>
                <td>{{ item.iban }}</td>
                <td>{{ item.mobile }}</td> -->
              </tr>
            </template>

          </v-data-table>
        </v-card>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { mapFields } from "../store/helpers";
import ReceiptViewer from "../components/ReceiptViewer";
import moment from "moment";

export default {
  components: {
    ReceiptViewer
  },
  data() {
    return {
      email: "",
      showDialog: false,
      receiptImageElement: new Image(),
      receiptImageIsLoading: true,
      receiptsList: [],
      emailValidity: true,
      headers: [
        {
          sortable: false,
          text: "Reference Number",
          value: "referenceNumber"
        },
        {
          sortable: true,
          text: "Campaign",
          value: "campaignId"
        },
        // {
        //   sortable: true,
        //   text: "Email",
        //   value: "email"
        // },
        {
          sortable: true,
          text: "Status",
          value: "status"
        },
        {
          sortable: true,
          text: "Created at",
          value: "createdAt"
        },
        {
          sortable: true,
          text: 'Updated at',
          value: "updatedAt"
        },
        // {
        //   sortable: false,
        //   text: "Reject Reason",
        //   value: "rejectReason"
        // },
        // {
        //   sortable: false,
        //   text: "Payment Status",
        //   value: "paymentStatus"
        // },
        // {
        //   sortable: false,
        //   text: "Payment History",
        //   value: "paymentHistory"
        // },
        // {
        //   sortable: false,
        //   text: "IBAN",
        //   value: "iban"
        // },
        // {
        //   sortable: false,
        //   text: "Mobile",
        //   value: "mobile"
        // },
      ],
    };
  },
  computed: {
    ...mapGetters(["userToken", "selectedDashboard"]),
    ...mapFields([
      "reClaimed",
      "reClaimText",
      "referenceNumber",
      "receiptImageURL",
      "createdAt",
      "createdAtDate",
      "createdAtTime",
      "status",
      "id",
      "campaignTitle",
      "campaign_fk",
      "receiptNumber",
      "total",
      "campaignRetailers",
      "hasWallet",
      "products",
      "couponsToCreate",
      "hasEditableCoupons",
      "productImageURL",
      "detailsText",
      "campaignEndDate",
      "campaignStartDate",
      "processedProducts",
      "productTotal",
      "retailerFk",
      "customerToken",
      "selectedProducts",
      "rejectReason",
      "total",
      "receiptId",
      "vatNumber",
      "paymentAmount",
      "receiptDateTime",
      "country",
      "postCode",
      "clubCode",
      "fiscalId",
      "rppData"
    ])
  },
  methods: {
    ...mapActions([
      "getReceiptsWithConsumerInfo",
      "getReceiptwithRefNumber",
      "getEmailParticipations",
      "getDashboardData",
      "getProductsList",
    ]),
    async searchEmail() {
      this.emailValidity = await this.validateEmail(this.email)
      // this.getEmailParticipations({
      //   userToken: this.userToken,
      //   email: this.email,
      //   dashboard: this.selectedDashboard
      // }).then(res => {
      //   this.receiptsList = res.receiptList;
      // });
      if(this.emailValidity){
        this.getReceiptsWithConsumerInfo({userToken: this.userToken, email: this.email, dashboard: this.selectedDashboard})
        .then(res => {
          this.receiptsList = res.receipts
        }).catch((e)=>{
          this.receiptsList = []
        })
      } else return
    },
    async validateEmail(email){
      try {
        let regex = /^[^@]+@[^@]+\.[^@]+$/
        let status = regex.test(email)
        if(status){
          return true
        } else return false
      } catch (e){
        console.error('Email validation failed: ', e)
        return false
      }
    },
    async setCurrentReceipt(item, campaign) {
      this.$refs.inspectMode=false;
      await this.getReceiptwithRefNumber({
        userToken: this.userToken,
        referenceNumber: item.referenceNumber,
        dashboard: this.selectedDashboard
      }).then(async res => {
        const receipt = res.receipt;

        if (this.selectedDashboard.isCroppable) {
          this.receiptImageURL = receipt.receiptFullImageURL;
        } else {
          this.receiptImageURL = receipt.receiptImageURL;
        }
        this.productImageURL = receipt.productImageURL;

        const payload = {
          userToken: this.userToken,
          dashboard: this.selectedDashboard,
          campaign_fk: receipt.campaign_fk
        };
        try {
          await this.getDashboardData(payload);
        } catch (e) {
          console.log("GET DASHBOARD DATA ERROR:: ", e);
        }
        this.img = new Image();
        this.receiptImageIsLoading = true;
        this.img.onload = () => {
          this.paymentAmount = receipt.paymentAmount;
          this.receiptImageIsLoading = false;
          this.receiptImageElement = this.img;
        };

        this.img.src = `${this.receiptImageURL}?${new Date().getTime()}`;
        this.createdAt = receipt.createdAt;
        this.campaignTitle = receipt.campaignTitle;
        this.campaign_fk = receipt.campaign_fk;
        this.receiptDateTime = receipt.receiptDateTime;
        this.createdAtTime = moment(receipt.updatedAt).format("HH:MM");
        this.createdAtDate = receipt.updatedAt;
        this.status = receipt.status;
        this.id = receipt.receiptToken;
        this.customerToken = receipt.customerToken;
        this.referenceNumber = receipt.referenceNumber;
        this.receiptNumber = receipt.identifiedId;
        this.total = receipt.total;
        this.postCode = receipt.postCode;
        this.receiptId = receipt.receiptId
        this.couponsToCreate = receipt.couponsPerReceipt;
        this.detailsText = receipt.detailsText;
        this.country = receipt.country;
        this.retailerFk =
          receipt.retailer == "15" ? "Not selected" : receipt.retailer;
        if (typeof this.retailerFk === "string") {
          this.retailerFk = parseInt(this.retailerFk);
        }
        this.campaign_fk = receipt.campaignId;
        this.rejectReason = receipt.rejectReason;
        this.paymentAmount = receipt.paymentAmount;
        if (receipt.clubCode) this.clubCode = receipt.clubCode;
        if (receipt.fiscalId) this.fiscalId = receipt.fiscalId;
        if (receipt.rppData) this.rppData = receipt.rppData;
        this.campaignEndDate = moment(receipt.campaignEndDate).format(
          "DD-MM-YYYY"
        );
        this.campaignStartDate = moment(receipt.campaignStartDate).format(
          "DD-MM-YYYY"
        );
        this.hasWallet = receipt.hasWallet;
        if (receipt.selectedProducts) {
          this.selectedProducts = JSON.parse(receipt.selectedProducts);
        }
        this.getProductsList({
          dashboard: this.selectedDashboard,
          campaignId: receipt.campaignId
        }).then(products => {
          if (products.length) {
            this.products = products;
            this.processedProducts = [];
            this.showDialog = true;
          } else if (this.selectedDashboard.campaignId === 'pg-ro') {
            this.products = products
            this.processedProducts = []
            this.showDialog = true
          }
        });

        if (this.couponsToCreate === -1) {
          this.hasEditableCoupons = true;
          this.couponsToCreate = 1;
        }
        this.campaignRetailers = res.campaignRetailers;
      });
    }
  },
  mounted() {
    if ("name" in this.selectedDashboard === false) {
      const dashboard = JSON.parse(localStorage.selectedDashboard);
      this.$store.commit("setDashboard", dashboard);
    }
    this.$store.commit("setUserRoles", JSON.parse(localStorage.userRoles));
  }
};
</script>
